
export default function Reach(){
    const onSubmit = async (event) => {
        event.preventDefault();
        
        const formData = new FormData(event.target);
    
        formData.append("access_key", process.env.REACT_APP_FORM_KEY);
        
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: json
        });
    
        const data = await response.json();
        // console.log(data)
        if (data.success) {
          alert("Thank you Our Team Will Contact You Soon...");
          event.target.reset();
        } else {
          console.log("Error", data);
          alert("Something Went Wrong. Feel Free To Call Us...")
        }
      };
    return(
        <section className="container reach">
            <main>
                <figure>
                <img src="../images/jewell_4.png" alt="jewel_4"/>
                </figure>
                <form onSubmit={onSubmit}>
                    <h2>Let us reach you</h2>
                    <div className="inputContainer">
                        <label>Name</label>
                        <input 
                            type="text"
                            name="Name"
                            required/>
                    </div>
                    <div className="inputContainer">
                        <label>Mobile Number</label>
                        <input 
                            type="tel"
                            name="Mobile Number"
                            required/>
                    </div>
                    <div className="inputContainer">
                        <label>Location</label>
                        <input 
                            type="text"
                            name="Location"
                            required/>
                    </div>
                    <div className="inputContainer">
                        <label>Sale/Release</label>
                        <select 
                            name="Sale/Release"
                            required>
                        <option hidden></option>
                        <option value={"Sale"}>Sale</option>
                        <option value={"Release"}>Release</option>
                        </select>
                    </div>
                    <button className="button-50 btnReverse submitBtn" type="submit">Book Now</button>
                </form>
            </main>
        </section>
    )
}